import { createFileRoute } from '@tanstack/react-router'

import SubmissionDetailPage from '@/components/pages/backoffice/_klb-petani/_poktan/submission/_$verificationId/container/DetailSubmissionPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/poktan/submission/$verificationId/'
)({
  component: SubmissionDetailPage
})
